import React, { useEffect, useLayoutEffect, useState } from "react";
import { isAndroid,isIOS } from 'react-device-detect';
import SkeletonS from 'react-loading-skeleton';
import './default.module.scss';

interface SkeletonProps{
    cardNumber:number
}

export function Skeleton ({
    cardNumber
}:SkeletonProps){

    const [currentSkeleton,setCurrentSkeleton] = useState(null);

    useEffect(()=>{

        let arr=null;
        if(cardNumber){
            arr=[];
            for(let i=0;i<cardNumber;i++){
                arr.push(i);
            }
        }
        setCurrentSkeleton(arr);
    },[cardNumber])

    useLayoutEffect(()=>{
        //var skeleton = $('#plp_grid_skeleton').scheletrone();
        if(currentSkeleton){
            //@ts-ignore
        }
    },[currentSkeleton])


    return     <div className="Skeleton__container" id="plp_grid_skeleton" data-scheletrone="true">
                    {
                        currentSkeleton &&  currentSkeleton.map((cardIndex)=><SkeletonS className="Skeleton__card" height={403} key={'skeleton_'+cardIndex}></SkeletonS>)
                    }

                </div>;


}